import {
  SAVE_ADDRESSES,
} from '../../actions/actionTypes'

import reducerCreator from './higherOrderEntityReducers/basicReducerCreator'

export default reducerCreator([
  SAVE_ADDRESSES,
])
